// import toast from "react-hot-toast";
import { APIEnv, APIResponse } from "@Src/services/learning/baseInterfaces";
import { NodeBookStoreBaseService } from "@Src/services/learning/base-services/NodeBookstoreBaseService";
import { NodeDashboardBaseService } from "./base-services/NodeDashBoardBaseService";
import { RedisBaseService } from "./base-services/RedisBaseService";
import { DotNetBaseService } from "./base-services/DotNetBaseService";
import toast from "react-hot-toast";
import { NodeEndmileBaseService } from "./base-services/NodeEndmileBaseService";
import { BookStoreBaseService } from "./base-services/BookStoreBaseService";
import { MarketingBaseService } from "./base-services/MarketingBaseService";
import { NodeDashboardBaseSessionMangementservice } from "./base-services/NodeDashboardSessionManagement";

const ApiService = {
    fetchData(param: any, ENV: APIEnv = APIEnv.LEARNING, customHeaders?: any) {
        param.headers = { ...param.headers, ...customHeaders }

        if (ENV === APIEnv.LEARNING) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeBookStoreBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.NODE_DASHBOARD) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeDashboardBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.MARKETING) {
            return new Promise<APIResponse>((resolve, reject) => {
                MarketingBaseService(param)
                    .then((response: any) => {
                        resolve(response?.data);
                    })
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.REDIS) {
            return new Promise<APIResponse>((resolve, reject) => {
                RedisBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.DOT_NET) {
            return new Promise<APIResponse>((resolve, reject) => {
                DotNetBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                        if (errors?.code === "ERR_NETWORK") {
                            toast.error(
                                "Unable to connect to server.Please try again later."
                            );
                        }
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.ENDMILE) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeEndmileBaseService(param)
                    .then(
                        (response: { data: APIResponse | PromiseLike<APIResponse> }) => {
                            resolve(response?.data);
                        }
                    )
                    .catch((errors: any) => {
                        reject(errors);
                    });
            });
        }
        if (ENV === APIEnv.NODE_BOOKSTORE) {
            return new Promise<APIResponse>((resolve, reject) => {
                BookStoreBaseService(param).then((response: { data: APIResponse | PromiseLike<APIResponse>; }) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                    reject(errors)
                })
            })
        }
         if (ENV === APIEnv.NODE_DASHBOARD_SESSION_MANAGEMENT) {
            return new Promise<APIResponse>((resolve, reject) => {
                NodeDashboardBaseSessionMangementservice(param).then((response: any ) => {
                    resolve(response?.data)
                }).catch((errors: any) => {
                    // toast.error(errors?.response?.data?.StatusMsg || '' + " " +errors?.response?.data?.data|| '' )
                    reject(errors)
                })
            })
        }
    },
};


export default ApiService;
